import type { AxiosResponse } from "axios";
import { Response } from "interfaces/utils/utils.interface";
import httpService from "plugins/axios";
import { logService } from "./log.service";

class Services {
  public get(page: string, pageSize: string): Promise<AxiosResponse<Response>> {
    return httpService.get<Response>(`admin/factory-quality/all?page=${page}&pageSize=${pageSize}`);
  }

  public getById(id: string): Promise<AxiosResponse<Response>> {
    return httpService.get<Response>(`admin/factory-quality/${id}`);
  }
  public create(data: any): Promise<AxiosResponse<Response>> {
    logService.create("manage_factory_quality");
    const formData = new FormData();
    formData.append("imgFile", data.imgFile);
    formData.append("videoFile", data.videoFile);
    formData.append("fileType", data.fileType);
    formData.append("nameTh", data.nameTh);
    formData.append("nameEn", data.nameEn);
    formData.append("detailTh", data.detailTh);
    formData.append("detailEn", data.detailEn);
    formData.append("isActive", data.isActive);
    return httpService.post<Response>(`admin/factory-quality`, formData);
  }
  public update(data: any): Promise<AxiosResponse<Response>> {
    logService.create("manage_factory_quality");
    const formData = new FormData();
    formData.append("imgFile", data.imgFile);
    formData.append("videoFile", data.videoFile);
    formData.append("fileType", data.fileType);
    formData.append("nameTh", data.nameTh);
    formData.append("nameEn", data.nameEn);
    formData.append("detailTh", data.detailTh);
    formData.append("detailEn", data.detailEn);
    formData.append("isActive", data.isActive);
    return httpService.patch<Response>(`admin/factory-quality/${data.id}`, formData);
  }
  public updateActive(data: any): Promise<AxiosResponse<Response>> {
    logService.create("manage_factory_quality");
    return httpService.patch<Response>(`admin/factory-quality/active/${data.id}`, {
      isActive: data.isActive,
    });
  }
  public delete(id: string): Promise<AxiosResponse<Response>> {
    logService.create("manage_factory_quality");
    return httpService.delete<Response>(`admin/factory-quality/${id}`);
  }
}

export const qualityService = new Services();
